module.exports = __webpack_public_path__ + "dist/img/how-it-works-transmission.3bf41173.svg";